import Vue from 'vue'
import App from './App.vue'
import router from "./router"
import frame from './plugins/frame'
import vuescroll from 'vuescroll';
import FetchCommonData from './plugins/FetchCommonData/v2'
Vue.use(FetchCommonData)

Vue.use(vuescroll);
Vue.config.productionTip = false
Vue.use(frame)
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
